import envService from '@/services/env.service';

const env = envService.getEnv();
const urlBase = env.VITE_DEPLOYMENT_TARGET === 'PROD' ? 'www.catchbio.com' : 'dev.catchbio.com';

export const Urls = {
  homepage: `https://${urlBase}/`,
  how_it_works: `https://${urlBase}/how-it-works`,
  our_mission: `https://${urlBase}/mission`,
  the_science: `https://${urlBase}/science`,
  sign_in: `http://${urlBase}/sign-in/`,
  terms_of_service: `http://${urlBase}/terms-of-service`,
  privacy_policy: `http://${urlBase}/privacy-policy`,
  faqs: `https://${urlBase}/faq`,
  blogs: `https://${urlBase}/blogs`,
  screening_sensitivity_specificity: `https://${urlBase}/blog/sensitivity-and-specificity-in-cancer-screening`,
};
